import store from "../../store";
import {http_request} from "../../httpConfig";
import {getPerspectivePoints} from "./getPerspectivePoints";
import {getBoundingBox} from "../Tools/pointsTools";

export const requestPerpectiveTexture = async function (options) {
    let plane;
    let scale;
    if (options.scale)
        scale = options.scale;
    else
        scale = 1;
    if (options.photoID) {
        let allPhotos = store.getters["active/GET_ALL_PHOTO"]
        plane = allPhotos[options.photoID].planeList[options.planeID];
    } else {
        plane = store.getters["active/PLANE_BY_ID"](options.planeID)
    }
    let pointList = plane.points

    let pointArray = getPerspectivePoints(options.planeID,options.photoID,scale);

    let boundingBox = getBoundingBox(pointList, 3);

    let inputData = {}
    if (options.photoID) {
        inputData.image_src = store.getters["active/GET_ALL_PHOTO"][options.photoID].src;
    }
    inputData.texture_src = options.texture_src;
    inputData.scale_factor = 1;
    inputData.roi = pointArray;
    inputData.roi.forEach((point)=>{
        point.x*=scale;
        point.y*=scale;
    })
    boundingBox.minPoint.x*=scale;
    boundingBox.minPoint.y*=scale;
    boundingBox.maxPoint.x*=scale;
    boundingBox.maxPoint.y*=scale;
    inputData.texture_factor = options.textureCoef*scale;
    // inputData.rect = [{'link': 4, 'x':  4.9, 'y': 173.1}, {'link': 1, 'x': 125.8, 'y': 387.8}]
    // console.log([minPoint, maxPoint])
    inputData.rect = [boundingBox.minPoint, boundingBox.maxPoint];
    //TODO в дальнейшем тут будут не active
    let size;
    size = await store.dispatch("active/GET_ACTIVE_IMG_SIZE");
    inputData.width = size.width*scale;
    inputData.height = size.height*scale;
    inputData.textureRotationAngle = options.textureRotationAngle;
    // console.log(scale)

    return http_request.post('/get_texture_with_perspective', inputData)
        .then((request) => {
            return request.data.out;
        })
        .catch((error) => {
            console.error(error);
        });

}
